import { render, staticRenderFns } from "./AppointmentInformation.vue?vue&type=template&id=720ed292&scoped=true&"
import script from "./AppointmentInformation.vue?vue&type=script&lang=js&"
export * from "./AppointmentInformation.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentInformation.vue?vue&type=style&index=0&id=720ed292&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ed292",
  null
  
)

export default component.exports